<template>
  <cv-header-menu aria-label="Lavori" title="Lavori - Attività" v-bind:hover-toggle="autoapertura" >
    <cv-header-menu-item href="/#/lavori">Lavori - Attività</cv-header-menu-item>
    <cv-header-menu-item href="/#/ricerca-lavori">Ricerca Lavori</cv-header-menu-item>
    <cv-header-menu-item href="/#/riepilogo-lavori">Riep. Lavori per Cliente</cv-header-menu-item>
    <hr style="width: 11em;">
    <cv-header-menu-item href="/#/colture">Colture</cv-header-menu-item>
    <cv-header-menu-item href="/#/lavori-tipo">Lavori Tipo</cv-header-menu-item>
    <hr style="width: 11em;">
    <cv-header-menu-item href="/#/operai">Operai</cv-header-menu-item>
    <cv-header-menu-item href="/#/ricerca-operai">Ricerca Operai</cv-header-menu-item>
  </cv-header-menu>
</template>

<script>
export default {
  name: "MenuLavori",
  props: {
    autoapertura: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>

</style>